import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import UA from '../ua';
var KNB = require('@dp/knb');
var KNBP = KNB.getPromiseInstance();
var isNative = UA.isNative;
var STORE_PREFIX = '_myshow_';
var _getExpireAt = Symbol('getExpireAt');
var _checkExpire = Symbol('checkExpire');
var _config = Symbol('config');
function checkLocalStorage() {
  // 检查浏览器是否支持 localStorage
  try {
    localStorage.setItem('test', '1');
    var isPassed = localStorage.getItem('test') === '1';
    localStorage.removeItem('test');
    return isPassed;
  } catch (e) {
    return false;
  }
}
var Store = /*#__PURE__*/function () {
  function Store() {
    _classCallCheck(this, Store);
    this.prefix = STORE_PREFIX;
    this.isLocalStorageAvailable = checkLocalStorage();
    if (!this.isLocalStorageAvailable) {
      window.owl && window.owl('addError', {
        name: 'localStorage 不可用'
      });
    }
  }
  _createClass(Store, [{
    key: "setPrefix",
    value: function setPrefix(prefix) {
      // 可更改前缀 prefix 实例共享
      this.prefix = prefix || STORE_PREFIX;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var level = arguments.length > 3 ? arguments[3] : undefined;
      // 注： 默认 localStorage
      var _this$_config = this[_config](key, opts),
        Key = _this$_config.Key,
        storage = _this$_config.storage,
        expires = _this$_config.expires,
        web = _this$_config.web;
      var item = JSON.stringify({
        expires: expires,
        data: value
      });
      return isNative ? KNBP.setStorage({
        level: level || 0,
        key: Key,
        value: item
      }) : Promise.resolve(storage.setItem(Key, item));
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var opts,
          _this$_config2,
          Key,
          storage,
          type,
          web,
          item,
          eObj,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _this$_config2 = this[_config](key, opts), Key = _this$_config2.Key, storage = _this$_config2.storage, type = _this$_config2.type, web = _this$_config2.web;
              if (!isNative) {
                _context.next = 8;
                break;
              }
              _context.next = 5;
              return KNBP.getStorage({
                type: 'native',
                key: Key
              }).then(function (res) {
                return res.value;
              }).catch(function (err) {
                console.warn(err);
              });
            case 5:
              _context.t0 = _context.sent;
              _context.next = 9;
              break;
            case 8:
              _context.t0 = storage.getItem(Key);
            case 9:
              item = _context.t0;
              try {
                item = JSON.parse(item);
              } catch (e) {
                if (item) {
                  eObj = {
                    name: 'Drip.getStore JSON parse 失败',
                    msg: JSON.stringify({
                      key: key,
                      item: item
                    })
                  };
                  window.owl && window.owl('addError', eObj);
                }
              }
              if (item) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", undefined);
            case 13:
              if (!this[_checkExpire](item)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return", item.data);
            case 15:
              this.remove(key, opts);
              return _context.abrupt("return", undefined);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "remove",
    value: function remove(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$_config3 = this[_config](key, opts),
        Key = _this$_config3.Key,
        storage = _this$_config3.storage,
        web = _this$_config3.web;
      if (isNative) {
        return new Promise(function (resolve, reject) {
          KNB.clearStorage({
            type: 'native',
            key: Key,
            success: resolve()
          });
        });
      } else {
        return Promise.resolve(storage.removeItem(Key));
      }
    }
  }, {
    key: _config,
    value: function value(key, opts) {
      if (typeof key !== 'string') throw new Error('Store ["key"] must be a string !');
      key = this.prefix + key;
      opts = Object.assign({
        session: false,
        expires: '1D'
      }, opts);
      opts.expires = this[_getExpireAt](opts.expires);
      return Object.assign({}, opts, {
        Key: key,
        storage: opts.session === true ? sessionStorage : localStorage,
        web: Boolean(opts.web)
      });
    }
  }, {
    key: _checkExpire,
    value: function value(data) {
      var expires = new Date(data.expires);
      var now = new Date();
      return expires !== 'Invalid Date' && expires > +new Date();
    }
  }, {
    key: _getExpireAt,
    value: function value(expires) {
      var time;
      var unit;
      if (/(\d+)(D|H|M)/.test(expires)) {
        time = +RegExp.$1;
        unit = RegExp.$2;
      } else {
        // 默认1D
        time = 1;
        unit = 'D';
        console.log('lifetime 配置不正确');
      }
      var now = new Date();
      var expireAt = now;
      var paddingLeft = function paddingLeft(num) {
        return num < 10 ? '0' + num : num;
      };
      switch (unit) {
        case 'D':
          expireAt.setDate(now.getDate() + time);
          break;
        case 'H':
          expireAt.setHours(now.getHours() + time);
          break;
        case 'M':
          expireAt.setMinutes(now.getMinutes() + time);
          break;
      }
      return expireAt.getFullYear() + '/' + paddingLeft(expireAt.getMonth() + 1) + '/' + paddingLeft(expireAt.getDate()) + ' ' + paddingLeft(expireAt.getHours()) + ':' + paddingLeft(expireAt.getMinutes()) + ':' + paddingLeft(expireAt.getSeconds());
    }
  }]);
  return Store;
}();
export default new Store();